import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { API_ENDPOINTS } from '../config/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const checkGoogleDriveToken = async () => {
    try {
      await axios.get(API_ENDPOINTS.auth.checkToken(), {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      return true;
    } catch (error) {
      if (error.response?.status === 401) {
        toast.warning('Google Drive bağlantınızı yenilemeniz gerekiyor.');
        logout();
      }
      return false;
    }
  };

  const refreshGoogleDriveToken = async () => {
    try {
      await axios.get(API_ENDPOINTS.auth.refreshToken(), {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      return true;
    } catch (error) {
      console.error('Token yenileme hatası:', error);
      return false;
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (token) {
          const userData = JSON.parse(localStorage.getItem('userData'));
          setUser(userData);
          await checkGoogleDriveToken();
        }
      } catch (error) {
        console.error('Auth check error:', error);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = async (credentialResponse) => {
    try {
      const response = await axios.post(API_ENDPOINTS.auth.googleAuth(), {
        credential: credentialResponse.credential
      });

      const { token, user } = response.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('userData', JSON.stringify(user));
      setUser(user);
      return user;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    checkGoogleDriveToken,
    refreshGoogleDriveToken
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}